import MainScene from './mainscene';

import helpConfig from 'cfg/help-config';
import {HelpScene} from 'helpscene';

import { TYPE, canGo } from 'network/network_api';
import { REQUEST_TYPE } from 'network/net';

import {SlotMath} from 'slot-math';

export default function construct(spec, space) {

    const mathSpec = {
        lines: spec.specification.linesCountMax,
        symbols: spec.specification.symbolsCount,
        wild: spec.specification.symbolWild,
        scatter: spec.specification.symbolScatter,
        bonus: spec.specification.symbolBonus,

        trajectories: spec.specification.linesPaths,
        price: spec.specification.priceList,
        scatterPrice: spec.specification.scatterWinCoeffs,
        substitutableElements: spec.specification.substitutableElements,
        wildLineWinMultiplier: spec.specification.wildLineWinMultiplier,
        freegamesMultiplier: spec.specification.freeSpinWinMultiplier,
        winShapes: spec.specification.winShapes,
        bonusWinCondition: 3 // признак наличия фригеймов которые предваряются псевдобонусом
    };

    const math = new SlotMath(mathSpec);

    // заглушка барабана чтобы библиотека могла работать будто без него - не думаю что он нам вообще пригодится:
    const stubBarrel = {
        container:new PIXI.Container(),
        delegate:null,
        show:()=>{},
        hide:()=>{},
        setCurrentElements:()=>{},
        setStopElements:()=>{},
        setDelegate:()=>{},
        setInfiniteRotate:()=>{},
        update:()=>{},
        startRotate:()=>{},
        interruptRotate:()=>{},
        stopRotate:()=>{},
        setBlurRotationTime:()=>{},
        setBlurSpeed:()=>{}
    };

    // const helpScene = new HelpScene(null/*controller*/, null/*model*/, math, helpConfig.help);
    // helpScene.visible = false;

    return {
        barrel:stubBarrel,
        slotScene: {
            view: new MainScene(spec, math, space),
            z: 0
        },
        doubleGameScene: {
            view: null
        },
        helpScene: {
            view: new HelpScene(null/*controller*/, null/*model*/, math, helpConfig.help),
            z: 1
        },
        bonusScene: {
            view: null
        },
        reactive
    };
}

function reactive( space, construct )
{
    const slotScene = construct.slotScene.view;

    //в игре невозможно остановить барабан потому что его нет:
    space.s( "ui:canInterruptBarrel" )
        .alter()
        .next( false );

    space.s( "state" )
        .filter( state => state.type == TYPE.REGULAR || state.type == TYPE.FREESPIN )
        .on( state =>  {
            slotScene.rotate(state.state.stage.math.symbols, state.state.math_info.source);
        });

    //очистка символов барабана при совершении запроса на сервер о получении следующего (на время запроса будет пустой барабан):
    space.s( "pending" )
        .filter( p => p == REQUEST_TYPE.SPIN )
        .merge( space.s( "slot:barrel:initiate" ) )
        .on( () => slotScene.readyForRound() );

    //восстановление барабана в статическом состоянии:
    space.s( "barrel:static" )
        .with( space.s( "state" ), ( _, state ) => state )
        .on( state => slotScene.steady( state.state.stage.math.symbols, state.state.math_info.source ) );
}



// WEBPACK FOOTER //
// ./src/construct.es6